import { FunctionComponent } from 'react'
import styled from 'styled-components'

import Spacer from 'components/Spacer'

import { convertToFullStateName } from 'utils/conversions'
import { getPublicListingSimplifiedStatus } from 'utils/statusHelpers'
import { addCommas } from 'utils/stringFormatting'

import LicensingData from 'data/MarketingData/LicensingData'

import * as T from 'types'
import * as E from 'types/enums'

const Container = styled.div`
  border: 1px solid ${props => props.theme.colors.black};
  border-radius: 4px;
  padding: 12px 20px;
`

const StreetAddress = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 27px;
  color: ${props => props.theme.colors.black};
`

const AddressDetails = styled(StreetAddress)`
  font-size: 14px;
  line-height: 19px;
`

const Price = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 62px;
  color: ${props => props.theme.colors.black};
`

const DetailsRow = styled.div`
  display: flex;
`

const DetailText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${props => props.theme.colors.black};
`

const LicensingInfo = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
`

interface IProps {
  listing: T.IListing
}

const ListingDetails: FunctionComponent<IProps> = ({ listing }) => {
  let bath = listing.bath ? listing.bath : 0

  if (listing.bathHalf) {
    bath += listing.bathHalf ? 0.5 : 0
  }

  const getLicensingInfo = (state: string) => {
    const key = convertToFullStateName[state]?.toLowerCase().split(' ').join('-')
    const licensingInfo = LicensingData[key]?.licensing
    return licensingInfo ? `Listing Provided by ${licensingInfo}` : ''
  }

  return (
    <Container>
      <StreetAddress>{`${listing.street} ${
        listing.aptNum ? `Unit ${listing.aptNum}` : ''
      }`}</StreetAddress>
      <AddressDetails>{`${listing.city}, ${listing.state} ${listing.zip}`}</AddressDetails>
      <Price>{`$${addCommas(listing.displayPrice || 0)}`}</Price>
      <DetailsRow>
        {listing.propertyType !== E.HomeTypeEnum.land
          ? (
            <>
              <DetailText>{`${listing.bed || 0} Beds`}</DetailText>
              <Spacer size={22} />
              <DetailText>{`${addCommas(bath)} Baths`}</DetailText>
              <Spacer size={22} />
              <DetailText>{`${addCommas(listing.sqft || 0)} sqft`}</DetailText>
            </>
          )
          : (
            <DetailText>{`${listing.lotSize || 0} ${listing.lotSizeType || 'Acres'}`}</DetailText>
          )}
      </DetailsRow>
      <Spacer size={5} />
      <DetailText>{getPublicListingSimplifiedStatus(listing.listingStatus)}</DetailText>
      <Spacer size={5} />
      <DetailText>{`MLS ID: ${listing.mlsList[0].number}`}</DetailText>
      <LicensingInfo>{getLicensingInfo(listing.state)}</LicensingInfo>
    </Container>
  )
}

export default ListingDetails
